/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { postOffline, getreceiptAccount } from '@/api';
import ImgUpload from '@/components/ImgUpload';
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
export default {
  name: 'offline',
  components: {
    ImgUpload: ImgUpload,
    Previewer: Previewer
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      from: {
        fk_t_shop_order_id: this.$route.params.id,
        transfer_name: '',
        transfer_amount: '',
        bank: '',
        pay_account: '',
        pay_time: '',
        pay_id: '',
        remark: '',
        electronic_receipt: []
      },
      pay: '',
      showPicker: false,
      currentDate: new Date(),
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          if (thumbnail) {
            var _thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        }
      }
    };
  },
  computed: {
    picsList: function picsList() {
      return (this.from.electronic_receipt || []).map(function (val) {
        return {
          src: val.file_url
        };
      });
    }
  },
  methods: {
    show: function show(index) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs['previewer'].show(index);
      });
    },
    onConfirm: function onConfirm(date) {
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      var H = date.getHours() + ':';
      var M2 = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      this.from.pay_time = Y + M + D + H + M2 + S;
      this.showPicker = false;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return postOffline(_this2.from);
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this2.$vux.toast.text(i18n.tc("338"));
                  _this2.$router.push({
                    name: 'orderDetails',
                    params: {
                      id: _this2.from.fk_t_shop_order_id
                    }
                  });
                  // this.$router.replace({ name: 'ServiceMallHome' })
                } else {
                  _this2.$vux.toast.text(i18n.tc("339"));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getreceiptAccounts: function getreceiptAccounts() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getreceiptAccount();
              case 2:
                res = _context2.sent;
                if (res.success) {
                  _this3.pay = res.data.value;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 复制内容
    copy: function copy() {
      var input = document.createElement('input');
      //将input的值设置为需要复制的内容
      input.value = this.pay;
      //添加input标签
      document.body.appendChild(input);
      //选中input标签
      input.select();
      //执行复制
      document.execCommand('copy');
      //成功提示信息
      this.$vux.toast.text(i18n.tc("635"));
      //移除input标签
      document.body.removeChild(input);
    },
    changePayTime: function changePayTime() {
      !this.$route.params.data && (this.showPicker = true);
    }
  },
  created: function created() {
    if (this.$route.params.price) {
      this.from.transfer_amount = this.$route.params.price;
    }
    this.getreceiptAccounts();
    if (this.$route.params.data) {
      this.from = this.$route.params.data;
    }
    console.log('AutoConsole: onSubmit -> this.from', this.from);
  },
  destroyed: function destroyed() {
    localStorage.removeItem('arrOrder');
  }
};